import axios from "axios";

export const UpdateUserAccount = async (data: any, headers: any) => {
  const res = await axios.post("/api/v1/updateUserWithFields", data, headers);
  return res.data;
};

export const UpdateShowByFields = async (data: any, headers: any) => {
  const res = await axios.post("/api/v1/update-show-by-fields", data, headers);
  return res.data;
};

export const UploadShowCapture = async (data: any, headers: any) => {
  const res = await axios.post("/api/v1/update-show-by-fields", data, headers);
  return res.data;
};

// Debate voting function
export const VoteOnDebate = async (
  debateId: string,
  optionId: string,
  headers: any,
) => {
  const res = await axios.post(
    `/api/debates/${debateId}/vote`,
    { option_id: optionId },
    headers,
  );
  return res.data;
};

// Metadata Admin functions
export const UpdateMetadataReview = async (
  metadataId: string,
  data: { reviewStatus: string; metadataJson?: string },
  headers: any,
) => {
  const res = await axios.put(
    `/api/admin/metadata/${metadataId}/review`,
    data,
    headers,
  );
  return res.data;
};

export const DeleteMetadata = async (metadataId: string, headers: any) => {
  const res = await axios.delete(`/api/admin/metadata/${metadataId}`, headers);
  return res.data;
};

// Admin Debates API functions
export const UpdateDebateAdmin = async (
  debateId: string,
  data: any,
  headers: any,
) => {
  const res = await axios.put(`/api/admin/debates/${debateId}`, data, headers);
  return res.data;
};

export const DeleteDebateAdmin = async (debateId: string, headers: any) => {
  const res = await axios.delete(`/api/admin/debates/${debateId}`, headers);
  return res.data;
};

// Admin Cache functions
export const ClearCache = async (headers: any) => {
  const res = await axios.post(`/api/admin/cache/clear`, {}, headers);
  return res.data;
};

export const RebuildRanks = async (headers: any) => {
  const res = await axios.post(`/api/admin/rebuild-ranks`, {}, headers);
  return res.data;
};

export const GetCacheStats = async (headers: any) => {
  const res = await axios.get(`/api/admin/cache/stats`, headers);
  return res.data;
};

// Profile management functions
export const UpdateProfile = async (
  data: {
    display_name?: string;
    generation?: number;
    profileImg?: string;
    bg_color?: string;
  },
  headers: any,
) => {
  const res = await axios.put("/api/profile/update", data, headers);
  return res.data;
};

// Upload profile image
export const UploadProfileImage = async (imageFile: File, headers: any) => {
  const formData = new FormData();
  formData.append("profileImage", imageFile);

  const res = await axios.post("/api/profile/upload-image", formData, {
    ...headers,
    headers: {
      ...headers.headers,
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

const Updates = {
  UpdateUserAccount,
  UpdateShowByFields,
  UploadShowCapture,
  VoteOnDebate,
  UpdateDebateAdmin,
  DeleteDebateAdmin,
  UpdateProfile,
  UploadProfileImage,
};

export default Updates;
